import headerBg2 from "@/assets/images/active/sakura/recall/header/header_bg2.png";
// import officeBtn from "@/assets/images/active/sakura/recall/header/btn_05.png";
// import loginBtn from "@/assets/images/active/sakura/recall/header/btn_06.png";
// import accountBtn from "@/assets/images/active/sakura/recall/header/btn_07.png";
// import logoutBtn from "@/assets/images/active/sakura/recall/header/btn_10.png";

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg2,
    style: "",
  },
  logged_in: {
    background_image: headerBg2,
    main_title_color: "#fff;font-size: 0.32rem;margin-top:0.25rem;",
    sub_title_color: "#fff",
    tips_color: "#fff",
    game_name: "魔卡少女樱：回忆钥匙",
    height: "1.7rem",
  },
  operation_btn: {
    office_website: {
      width: "",
      height: "",
      background_image: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/recall/header/btn_05.png",
      style: "top: 0.3rem;",
      link: "https://sakura.qingcijoy.com/official/index.html",
    },
    login: {
      width: "",
      height: "",
      background_image: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/recall/header/btn_06.png",
      style: "top: 0.3rem;",
    },
    change_account: {
      width: "",
      height: "",
      background_image: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/recall/header/btn_07.png",
      style: "top: 0.3rem;",
    },
    join_active: {
      width: "",
      height: "",
      background_image: "",
      img: "",
      style: "",
    },
    logout: {
      width: "",
      height: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/recall/header/btn_10.png",
      style: "top: 0.3rem;",
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/sakura/recall/headerConfig.js